import createAppSlice from 'app/createAppSlice';
import { PayloadAction } from '@reduxjs/toolkit';
import { IPlan } from './types';

const initialState: IPlan = {
  entitlements: {},
};

const PlanSlice = createAppSlice({
  name: 'plan',
  initialState,
  reducers: {
    setPlanEntitlements: (
      state,
      action: PayloadAction<IPlan['entitlements']>,
    ) => {
      state.entitlements = action.payload;
    },
  },
});

export const { setPlanEntitlements } = PlanSlice.actions;
export default PlanSlice.reducer;
